/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/dog'
export default icon
